import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { PlanService } from "../../Services";
import Loader from "../../Components/Loader";

export const PlanList = () => {
  const history = useHistory();
  const [plans, setPlans] = useState([]);
  const [addons, setAddons] = useState([]);
  const [loader, setLoader] = useState(true);
  const [activeTab, setActiveTab] = useState("plans"); // 'plans' or 'addons'

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoader(true);
    Promise.all([PlanService.getPlans(), PlanService.getAddons()])
      .then(([planRes, addonRes]) => {
        if (planRes.status) setPlans(planRes.data);
        if (addonRes.status) setAddons(addonRes.data);
        setLoader(false);
      })
      .catch(err => {
        console.log(err);
        setLoader(false);
      });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            
            {/* Nav tabs */}
            <ul className="nav nav-tabs nav-tabs-custom nav-justified mb-4" role="tablist">
              <li className="nav-item">
                <a className={`nav-link ${activeTab === 'plans' ? 'active' : ''}`} onClick={() => setActiveTab('plans')} style={{ cursor: 'pointer' }}>
                  <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                  <span className="d-none d-sm-block fw-bold" style={{ fontSize: '1rem' }}>Subscription Plans</span>
                </a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${activeTab === 'addons' ? 'active' : ''}`} onClick={() => setActiveTab('addons')} style={{ cursor: 'pointer' }}>
                  <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                  <span className="d-none d-sm-block fw-bold" style={{ fontSize: '1rem' }}>Manage Addons</span>
                </a>
              </li>
            </ul>

            {/* Tab content */}
            <div className="tab-content text-muted">
              
              {/* Plans Tab */}
              {activeTab === 'plans' && (
                <div className="tab-pane active" role="tabpanel">
                  <div className="d-flex justify-content-end mb-3">
                    <button className="btn btn-primary w-sm waves-effect waves-light" onClick={() => history.push("/add-plan")}>
                      Add Plan
                    </button>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-centered table-nowrap mb-0 table-bordered text-center">
                      <thead className="table-light">
                        <tr>
                          <th>Plan Name</th>
                          <th>Type</th>
                          <th>Monthly Price</th>
                          <th>Yearly Price</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {plans && plans.length > 0 ? (
                          plans.map((item, index) => (
                            <tr key={index}>
                              <td>{item.name}</td>
                              <td>{item.type_name || '-'}</td>
                              <td>${item.monthly_price || 0}</td>
                              <td>${item.yearly_price || 0}</td>
                              <td><span className={`badge bg-${item.status === 'ACTIVE' ? 'success' : 'danger'}`}>{item.status}</span></td>
                              <td>
                                <button className="btn btn-info btn-sm" onClick={() => history.push("/edit-plan?id=" + item._id, item)}>
                                  Edit
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="6">No plans found</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Addons Tab */}
              {activeTab === 'addons' && (
                <div className="tab-pane active" role="tabpanel">
                  <div className="d-flex justify-content-end mb-3">
                    <button className="btn btn-success w-sm waves-effect waves-light" onClick={() => history.push("/add-addon")}>
                      Add Addon
                    </button>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-centered table-nowrap mb-0 table-bordered text-center">
                      <thead className="table-light">
                        <tr>
                          <th>Addon Name</th>
                          <th>Type</th>
                          <th>Price</th>
                          <th>Duration</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {addons && addons.length > 0 ? (
                          addons.map((item, index) => (
                            <tr key={index}>
                              <td>{item.name}</td>
                              <td>{item.type_name || '-'}</td>
                              <td>${item.price}</td>
                              <td>{item.duration}</td>
                              <td><span className={`badge bg-${item.status === 'ACTIVE' ? 'success' : 'danger'}`}>{item.status}</span></td>
                              <td>
                                <button className="btn btn-info btn-sm" onClick={() => history.push("/edit-addon?id=" + item._id, item)}>
                                  Edit
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="6">No addons found</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
